import axios from 'axios';

const SPREADSHEET_ID_PATTERN = /^[a-zA-Z0-9_-]+$/;

export function extractSpreadsheetId(value: string): string {
  const trimmed = value.trim();
  const urlMatch = trimmed.match(/docs\.google\.com\/spreadsheets\/d\/([a-zA-Z0-9_-]+)/i);
  return urlMatch?.[1] || trimmed;
}

export function getSpreadsheetUrl(value: string): string | undefined {
  const spreadsheetId = extractSpreadsheetId(value);
  return spreadsheetId && SPREADSHEET_ID_PATTERN.test(spreadsheetId)
    ? `https://docs.google.com/spreadsheets/d/${spreadsheetId}/edit`
    : undefined;
}

export async function validateSpreadsheet(apiKey: string, value: string): Promise<boolean> {
  const spreadsheetId = extractSpreadsheetId(value);
  if (!apiKey.trim() || !spreadsheetId || !SPREADSHEET_ID_PATTERN.test(spreadsheetId)) return false;

  try {
    await axios.get(`https://sheets.googleapis.com/v4/spreadsheets/${spreadsheetId}`, {
      params: {
        key: apiKey.trim(),
        fields: 'spreadsheetId',
      },
      timeout: 10000,
    });
    return true;
  } catch {
    return false;
  }
}
